import { NotificationType } from '@/models/enums/app/NotificationType'
import type { Notification } from '@/models/interfaces/Notification'
import { useApplicationStore } from '@/stores/applicationStore'
import { POSITION, useToast } from 'vue-toastification'

export const addNotification = (
  message: string,
  notificationType = NotificationType.INFO,
  description?: string,
) => {
  const appStore = useApplicationStore()
  const notification: Notification = {
    id: Date.now(),
    message,
    description,
    type: notificationType,
  }
  appStore.notificationPile.push(notification)

  const toast = useToast()
  const content = description ? `${message} ${description}` : message
  const toastOptions = { timeout: 3000, position: POSITION.TOP_CENTER }

  switch (notificationType) {
    case NotificationType.SUCCESS:
      toast.success(content, toastOptions)
      break
    case NotificationType.ERROR:
      toast.error(content, toastOptions)
      break
    default:
      toast.info(content, toastOptions)
      break
  }
}
